module.exports = ".report-footer {\n  font-size: 1.5rem; }\n\n.col-concepto, .col-miembro {\n  min-width: 150px; }\n\n.wrapper-header-sticky {\n  overflow-y: scroll;\n  max-height: 550px; }\n\n.wrapper-header-sticky thead, .wrapper-header-sticky thead th {\n  position: sticky;\n  position: -webkit-sticky;\n  top: 0;\n  background-color: #fff; }\n\n@media print {\n  .wrapper-header-sticky {\n    overflow-y: visible;\n    max-height: unset; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/reporte-cxc/reporte-cxc.component.scss
// module id = ./src/app/components/reporte-cxc/reporte-cxc.component.scss
// module chunks = main